import React from "react";
import {
	Card,
	CardContent,
	Typography,
	Box,
} from "@material-ui/core";
import { TabGroup } from "src/components/CheckPro/TabGroup";
import { GeneralInfoTab } from "./PdfConfiguration/GeneralInfoTab";
import { InspectionScopeTab } from "./PdfConfiguration/InspectionScopeTab";
import { LegalScopeTab } from "./PdfConfiguration/LegalScopeTab";
import { MetricInspectionTab } from "./PdfConfiguration/MetricInspectionTab";
import { NomenclatureTab } from "./PdfConfiguration/NomenclatureTab";

const PdfConfigSection: React.FC<{ title: string; description?: string }> = ({ 
	title, 
	description 
}) => (
	<Card>
		<CardContent>
			<Typography variant="h6" gutterBottom>
				{title}
			</Typography>
			{description && (
				<Typography variant="body2" color="textSecondary">
					{description}
				</Typography>
			)}
			<Box mt={2}>
				<Typography variant="body1">
					Configuración para la sección "{title}" del reporte PDF
				</Typography>
				<Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
					Aquí se configurarán las opciones específicas para esta sección del reporte.
				</Typography>
			</Box>
		</CardContent>
	</Card>
);

export const BusinessPdfConfigurationTab = () => {
	return (
		<TabGroup
			variant="scrollable"
			tabs={[
				"Portada",
				"Información General",
				"Alcances de la Inspección",
				"Alcances Legales",
				"Inspección Métrica",
				"Nomenclatura"
			]}
			style={{
				marginBottom: 10,
			}}
		>
			<PdfConfigSection 
				title="Portada"
				description="Configuración de la portada del reporte PDF"
			/>
			<GeneralInfoTab />
			<InspectionScopeTab />
			<LegalScopeTab />
			<MetricInspectionTab />
			<NomenclatureTab />
		</TabGroup>
	);
};